module.exports = __webpack_public_path__ + "img/DocGlossHdrWaypoint.bde8b4fc.png";